import SendIcon from '../assets/icons/send.svg';
import UndoIcon from '../assets/icons/undo.svg';
import GearIcon from '../assets/icons/gear.svg';
import RestartIcon from '../assets/icons/restart.svg';
import CloseIcon from '../assets/icons/close.svg';
import BackIcon from '../assets/icons/back.svg';
import DoubleArrowDownIcon from '../assets/icons/double-arrow-down.svg';
import DoubleArrowUpIcon from '../assets/icons/double-arrow-up.svg';
export default {
  SendIcon,
  UndoIcon,
  GearIcon,
  RestartIcon,
  CloseIcon,
  DoubleArrowDownIcon,
  DoubleArrowUpIcon,
  BackIcon
};
//# sourceMappingURL=icons.js.map